import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AboutIndustryItem } from '../../about.models';

@Component({
  selector: 'app-about-industries-section',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './about-industries-section.component.html',
  styleUrl: './about-industries-section.component.scss'
})
export class AboutIndustriesSectionComponent {
  @Input({ required: true }) industries: AboutIndustryItem[] = [];
}
